<template>

    <div id="app">
        <header>
            <div class="navbar navbar-dark bg-dark box-shadow">
                <div class="container d-flex justify-content-center">
                    <a href="#" class="navbar-brand d-flex align-items-center">
                        <img src="https://bookieboost.com/wp-content/uploads/2014/06/BookieBoost-Icon3.png" width="32"
                             height="32" class="rounded mr-2">
                        <strong>Accumulator Tip Builder</strong>
                    </a>
                    <span class="text-white">{{ country }}</span>
                </div>
            </div>
        </header>

        <main role="main">
            <div class="container pt-4">
                <div class="row justify-content-md-center">
                    <div class="col-md-9 mb-5">
                        <div class="alert alert-warning mb-4" v-if="noData && !loadingMessage && !loadingData">
                            No possible accumulators. Try other parameters.
                        </div>
                        <div class="card" v-if="!accumulator && !loadingData && !loadingMessage">
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Bookmaker</label>
                                    <select class="form-control" v-model="feed">
                                        <option v-for="feed in feeds" :value="feed.id" :key="feed.id">{{ feed.name }}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Bet type</label>
                                    <select class="form-control" v-model="type">
                                        <option value="0">Both teams to score</option>
                                        <option value="1">Full time result</option>
                                        <option value="4">Under/over 2.5</option>
                                        <option value="2" v-if="hasBttsAndFtr">BTTS & Full time result</option>
                                        <option value="3">Mixed</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Number of bets</label>
                                    <select class="form-control" v-model="fold">
                                        <option :value="3">Treble</option>
                                        <option v-for="fold in [4,5,6,7,8,9,10]" :value="fold">{{ fold }}-Fold</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Prefer hot favourites</label>
                                    <select class="form-control" v-model="lowestOdds">
                                        <option value="0">No</option>
                                        <option value="1">Yes</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Available competitions (select to include or leave blank for random)</label>
                                    <div class="row">
                                        <div class="col-md-6" v-for="competition in competitions">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" :value="competition.id"
                                                       v-model="selectedCompetitions">
                                                <label class="form-check-label">
                                                    {{ competition.country_name }} {{ competition.name }} ({{
                                                    competition.outcomes_count }})
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <button type="submit" class="btn btn-primary btn-block" @click="generate"
                                        :disabled="loadingMessage || loadingData">Build Tip
                                </button>
                            </div>
                        </div>
                        <div class="card" v-if="accumulator">
                            <div class="card-body">
                                <h4>{{ accumulator.type_name }} {{ accumulatorFold }}</h4>
                                <p>Odds: {{ accumulator.odd_fractional }} at {{ accumulator.feed.name }} (odds may
                                    change)</p>
                                <h5>Bet Details:</h5>
                                <table class="table table-sm">
                                    <tr v-for="bet in accumulator.bets">
                                        <td>{{ bet.date | moment("MMM D, H:mm") }}</td>
                                        <td>{{ bet.homeTeam }} v {{ bet.awayTeam }}</td>
                                        <td>{{ outcomeName(bet.outcome) }}</td>
                                    </tr>
                                </table>
                                <a :href="accumulator.short_link" class="btn btn-block btn-primary btn-lg"
                                   target="_blank">Load selections to
                                    betslip</a>
                                <button class="btn btn-block btn-secondary" @click="accumulator = null">Build another
                                    tip
                                </button>
                                <p class="mt-3">New {{ accumulator.feed.name }} customers can join here: <a
                                        :href="accumulator.feed.link"
                                        target="_blank"><b>Click to join</b></a> (18+ T&Cs apply)</p>
                            </div>
                        </div>
                        <div class="card text-center uppercase py-3" v-if="loadingData">
                            <div class="card-body">
                                <spinner></spinner>
                                <span class="text-uppercase">Combining tips</span>
                            </div>
                        </div>
                        <div class="card text-center py-3" v-if="loadingMessage">
                            <div class="card-body">
                                <spinner></spinner>
                                <span class="text-uppercase">Building your betslip</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import Spinner from 'vue-simple-spinner'

    export default {
        name: 'app',
        data: function () {
            return {
                feed: null,
                competition: null,
                type: 0,
                fold: 3,
                lowestOdds: 0,
                feeds: [],
                selectedCompetitions: [],
                competitions: {},
                accumulator: null,
                noData: false,
                loadingData: false,
                loadingMessage: false,
                country: '',
            }
        },
        components: {
            Spinner
        },
        mounted: function () {
            this.axios.get('https://link.bookieboost.com/generator').then(({data}) => {
                this.feeds = data.feeds;
                this.competitions = data.competitions;
                this.country = data.country;

                this.feed = this.feeds[0].id;
            })
        },
        computed: {
            accumulatorFold: function () {
                let fold = this.accumulator.bets_count;
                return fold == 3 ? 'Treble' : fold + '-Fold Accumulator';
            },
            hasBttsAndFtr: function () {
                if (!this.feeds.length) {
                    return true;
                }

                let feedId = this.feed;

                console.log(this.feeds.length);

                return this.feeds.find(function (feed) {
                    return feed.id === feedId;
                }, this).has_btts_and_ftr_type;
            }
        },
        methods: {
            generate: function () {
                this.accumulator = null;
                this.loadingData = true;
                this.axios.get('https://link.bookieboost.com/generator/accumulator', {
                    params: {
                        feed: this.feed,
                        fold: this.fold,
                        competitions: this.selectedCompetitions,
                        type: this.type,
                        lowest_odds: this.lowestOdds,
                    }
                }).then((response) => {
                    this.loadingData = false;

                    if (response.status === 204) {
                        this.noData = true;
                        this.accumulator = null;
                    } else {
                        this.loadingMessage = true;
                        setTimeout(() => {
                            this.loadingMessage = false;
                            this.noData = false;

                            response.data.bets = Object.values(response.data.bets).sort(function (a, b) {
                                return a.date.localeCompare(b.date);
                            });

                            this.accumulator = response.data;
                        }, 2000);
                    }
                }).catch(() => {
                    this.noData = true;
                    this.loadingMessage = false;
                    this.loadingData = false;
                });
            },
            outcomeName: function (id) {
                const mixed = this.accumulator.type == 3;
                switch (id) {
                    case 0:
                        return mixed ? 'BTTS: Yes' : 'Yes';
                    case 1:
                        return mixed ? 'BTTS: No' : 'No';
                    case 2:
                        return mixed ? 'FT Result: Home' : 'Home';
                    case 3:
                        return mixed ? 'FT Result: Draw' : 'Draw';
                    case 4:
                        return mixed ? 'FT Result: Away' : 'Away';
                    case 5:
                        return mixed ? 'BTTS & FTR: Yes & Home' : 'Yes & Home';
                    case 6:
                        return mixed ? 'BTTS & FTR: Yes & Draw' : 'Yes & Draw';
                    case 7:
                        return mixed ? 'BTTS & FTR: Yes & Away' : 'Yes & Away';
                    case 8:
                        return mixed ? 'BTTS & FTR: No & Home' : 'No & Home';
                    case 9:
                        return mixed ? 'BTTS & FTR: No & Draw' : 'No & Draw';
                    case 10:
                        return mixed ? 'BTTS & FTR: No & Away' : 'No & Away';
                    case 11:
                        return mixed ? 'O/U: Over 2.5' : 'Over 2.5';
                    case 12:
                        return mixed ? 'O/U: Under 2.5' : 'Under 2.5';
                }
            },
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue